export type IncidentNotificationReference = {
  type: string
  incidentId?: string | null
}

export const getIncidentNotificationPath = (
  notification: IncidentNotificationReference
): string | null => {
  if (
    (!notification.type.startsWith('incident_') && notification.type !== 'employee_communication') ||
    !notification.incidentId
  ) return null
  return `/incident?tab=detail&id=${encodeURIComponent(notification.incidentId)}`
}
